import { ApolloError } from "@apollo/client";

/**
 * Cleans noise from Apollo mutation/query error messages
 *
 * Example: '[GraphQL Error]: In field "createUser": SomeError' to 'SomeError'
 **/
export const cleanApolloErrorMessage = (errorMessage: string): string =>
  errorMessage.replace(/GraphQL Error: In field ".+":\s/gi, "");

/** First GraphQL error message from an ApolloError, or `fallback` when absent. */
export const getApolloErrorMessage = (err: unknown, fallback = ""): string => {
  const gqlMessage = err instanceof ApolloError ? err.graphQLErrors[0]?.message : "";
  return gqlMessage || fallback;
};
